import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, languages } from '../data/mock';

const LanguageContext = createContext();
const LANGUAGE_STORAGE_KEY = 'gws-lang';

const getStoredLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  const savedLang = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return languages.find((language) => language.code === savedLang) ? savedLang : 'en';
};

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(getStoredLanguage);
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    const lang = languages.find((l) => l.code === currentLang);
    if (lang) {
      setDirection(lang.dir);
      document.documentElement.dir = lang.dir;
      document.documentElement.lang = currentLang;
    }
  }, [currentLang]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[currentLang];
    for (const k of keys) {
      value = value?.[k];
    }
    if (value) return value;

    let fallback = translations.en;
    for (const k of keys) {
      fallback = fallback?.[k];
    }
    return fallback || key;
  };

  const changeLang = (code) => {
    setCurrentLang(code);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  };

  useEffect(() => {
    const savedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (savedLang && languages.find((l) => l.code === savedLang)) {
      setCurrentLang(savedLang);
    }
  }, []);

  return (
    <LanguageContext.Provider
      value={{
        currentLang,
        direction,
        t,
        changeLang,
        languages,
        isRTL: direction === 'rtl',
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
